export default "<m-sphere\n    color=\"red\"\n    y=\"2\"\n></m-sphere>\n";